import { format, formatDistanceToNowStrict, differenceInCalendarDays, isToday, isYesterday, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export const CATEGORY_STYLES = {
  Casa: { color: "#13C9A3", icon: "Home" },
  Carro: { color: "#4E78FF", icon: "Car" },
  Família: { color: "#7657E8", icon: "Users" },
  Documentos: { color: "#0A6373", icon: "FileText" },
  Objetos: { color: "#F59E0B", icon: "Package" },
  Compras: { color: "#EC4899", icon: "ShoppingBag" },
  Manutenção: { color: "#0EA5E9", icon: "Wrench" },
  Pets: { color: "#8B5CF6", icon: "PawPrint" },
  Emprestados: { color: "#F97316", icon: "HandCoins" },
  Trabalho: { color: "#05324A", icon: "Briefcase" },
  Viagem: { color: "#06B6D4", icon: "Plane" },
  Outros: { color: "#64748B", icon: "Sparkles" },
};

export const catStyle = (name) => CATEGORY_STYLES[name] || { color: "#0A6373", icon: "Tag" };

export function relativeDate(iso) {
  if (!iso) return "";
  const d = typeof iso === "string" ? parseISO(iso) : iso;
  if (isToday(d)) return "Hoje";
  if (isYesterday(d)) return "Ontem";
  const days = differenceInCalendarDays(new Date(), d);
  if (days < 30) return `${days} dias atrás`;
  return format(d, "d 'de' MMM", { locale: ptBR });
}

export function longDate(iso) {
  if (!iso) return "";
  const d = iso.length === 10 ? parseISO(iso + "T12:00:00") : parseISO(iso);
  return format(d, "d 'de' MMMM 'de' yyyy", { locale: ptBR });
}

export function shortDate(iso) {
  if (!iso) return "";
  const d = iso.length === 10 ? parseISO(iso + "T12:00:00") : parseISO(iso);
  return format(d, "dd/MM/yyyy", { locale: ptBR });
}

export function countdown(iso) {
  const d = parseISO(iso);
  const days = differenceInCalendarDays(d, new Date());
  if (days === 0) return { label: "É hoje", tone: "warn" };
  if (days === 1) return { label: "Amanhã", tone: "ok" };
  if (days > 1) return { label: `Faltam ${days} dias`, tone: "ok" };
  if (days === -1) return { label: "Atrasado há 1 dia", tone: "late" };
  return { label: `Atrasado há ${Math.abs(days)} dias`, tone: "late" };
}

export const money = (v) => (v == null ? null : v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));

export const RECURRENCES = [
  { value: "once", label: "Uma vez" },
  { value: "daily", label: "Diário" },
  { value: "weekly", label: "Semanal" },
  { value: "monthly", label: "Mensal" },
  { value: "yearly", label: "Anual" },
  { value: "custom", label: "Personalizado" },
];

export const recurrenceLabel = (r, days) => (r === "custom" ? `A cada ${days || "?"} dias` : RECURRENCES.find((x) => x.value === r)?.label || "Uma vez");

export const timeAgoStrict = (iso) => formatDistanceToNowStrict(parseISO(iso), { locale: ptBR, addSuffix: true });

export const PLAN_NAMES = { free: "Clicou, Guardou! Free", plus: "Clicou, Guardou! Premium", familia: "Clicou, Guardou! Família" };

export const formatBytes = (b) => (b >= 1024 ** 3 ? `${(b / 1024 ** 3).toFixed(1)} GB` : b >= 1024 ** 2 ? `${Math.round(b / 1024 ** 2)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
